"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiData_1 = __importDefault(require("@/api/class/ApiData"));
const overdueApi = {
    overdueList: new ApiData_1.default({
        name: '逾期记录列表',
        url: 'web/cs-overdue-record/pageList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueExport: new ApiData_1.default({
        name: '逾期记录导出',
        url: 'web/cs-overdue-record/export',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueListInfo: new ApiData_1.default({
        name: '逾期记录详情',
        url: 'web/cs-overdue-record/getByOverdueRecordId',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueListBuild: new ApiData_1.default({
        name: '逾期记录新增',
        url: 'web/cs-overdue-record/create',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueListChange: new ApiData_1.default({
        name: '逾期记录编辑',
        url: 'web/cs-overdue-record/modify',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueListDelete: new ApiData_1.default({
        name: '逾期记录删除',
        url: 'web/cs-overdue-record/deletes',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueContractInfo: new ApiData_1.default({
        name: '合同基本信息',
        url: 'web/ufoleasing/getContractInfoByContractId',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueContractExtraInfo: new ApiData_1.default({
        name: '合同附属信息',
        url: 'web/csContractExt/info',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    changeOverdueContractExtraInfo: new ApiData_1.default({
        name: '合同附属信息',
        url: 'web/csContractExt/addOrUpdate',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueRentPlan: new ApiData_1.default({
        name: '合同租金计划',
        url: 'web/ufoleasing/getRentPlanByContractId',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueDealerInfo: new ApiData_1.default({
        name: '经销商信息',
        url: 'web/ufoleasing/getOrgInfo',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueVehicleInfo: new ApiData_1.default({
        name: '车辆信息',
        url: 'web/ufoleasing/getVehicleInfo',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueNaturalPersonGuarantee: new ApiData_1.default({
        name: '自然人担保',
        url: 'web/ufoleasing/getAssure1',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueCorporateGuarantee: new ApiData_1.default({
        name: '法人担保',
        url: 'web/ufoleasing/getAssure2',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueAffiliationGuarantee: new ApiData_1.default({
        name: '挂靠担保',
        url: 'web/ufoleasing/getAssure3',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueSpecialSituationChange: new ApiData_1.default({
        name: '逾期记录特殊情况修改',
        url: 'web/cs-overdue-record/update',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueCollectionList: new ApiData_1.default({
        name: '逾期催收列表',
        url: 'web/cs-collection-record/listByContractNum',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueCollectionBuild: new ApiData_1.default({
        name: '逾期催收新增',
        url: 'web/cs-collection-record/add',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueContactsList: new ApiData_1.default({
        name: '逾期联系人列表',
        url: 'web/cs-overdue-relate/list',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueAllContactsList: new ApiData_1.default({
        name: '逾期所有联系人列表',
        url: 'web/cs-overdue-relate/listAllOldAndNew',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueContactsBuild: new ApiData_1.default({
        name: '逾期联系人新增',
        url: 'web/cs-overdue-relate/add',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueLetterReminderList: new ApiData_1.default({
        name: '函催列表',
        url: 'web/cs-case-collection-record/list',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueLetterReminderBuildOverdue: new ApiData_1.default({
        name: '生成律师函',
        url: 'web/cs-case-collection-record/new/overdue-notice',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueLetterReminderBuildCollection: new ApiData_1.default({
        name: '生成催告函',
        url: 'web/cs-case-collection-record/new/collection-letter',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueLetterReminderChange: new ApiData_1.default({
        name: '催告函发送记录',
        url: 'web/cs-case-collection-record/modify',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueGuarantorList: new ApiData_1.default({
        name: '追加担保人列表',
        url: 'web/cs-guarantor/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueGuarantorInfo: new ApiData_1.default({
        name: '追加担保人详情',
        url: 'web/cs-guarantor/info',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueGuarantorBuildOrChange: new ApiData_1.default({
        name: '追加担保人新增',
        url: 'web/cs-guarantor/create',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueDeductionList: new ApiData_1.default({
        name: '扣款明细',
        url: 'web/ufoleasing/getDeductionDetailList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueAssignList: new ApiData_1.default({
        name: '分派记录',
        url: 'web/cs-collection-assign-record/pageList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    overdueAssignUser: new ApiData_1.default({
        name: '分派催收/上门人员',
        url: 'web/cs-collection-assign-record/userAssign',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    customerContacts: new ApiData_1.default({
        name: '获取联系人',
        url: 'web/ufoleasing/getContactsByCustomerid',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    messageTemplate: new ApiData_1.default({
        name: '短信模板',
        url: 'web/csSmsTemplate/list',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    pushMessage: new ApiData_1.default({
        name: '发送短信',
        url: 'web/csSmsSendLog/send',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    messageList: new ApiData_1.default({
        name: '短信记录',
        url: 'web/csSmsSendLog/overdueSmsLogPage',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
};
exports.default = overdueApi;
